import React from "react";
import { createPortal } from "react-dom";
import { Image } from "react-bootstrap";
import Truncate from "src/components/truncate";
import { FileService } from "src/utils/file.service";
import styles from "./citationTooltip.module.scss";
import Thumbnail from "src/components/thumbnail";

export interface CitationTooltipProps {
  hoveredCite: {
    citeIndex: number;
    targetEl: HTMLElement;
  } | null;
  contents: any[];
  onMouseEnter: () => void;
  onMouseLeave: () => void;
}

const CitationTooltip: React.FC<CitationTooltipProps> = ({
  hoveredCite,
  contents,
  onMouseEnter,
  onMouseLeave,
}) => {
  if (!hoveredCite) return null;

  const citeAsset = contents[hoveredCite.citeIndex - 1];
  const rect = hoveredCite.targetEl.getBoundingClientRect();

  if (!citeAsset) {
    return null;
  }

  return createPortal(
    <div
      className={styles.citeTooltipPortal}
      style={{
        position: "fixed",
        left: rect.left + rect.width / 2,
        top: rect.top - 8,
        transform: "translate(-50%, -100%)",
        zIndex: 1001,
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className={styles.citeTooltipOverlay}>
        <Thumbnail media={citeAsset.icon} width={200} className={styles.citeTooltipIcon} alt="" defaultImage="/images/assets/default_asset.jpg" />
        <div className={styles.citeTooltipDetails}>
          <Truncate className={styles.citeTooltipTitle} width={130}>
            {citeAsset?.name}
          </Truncate>
          <p className={styles.citeTooltipMetadata}>
            {FileService.getFileType(citeAsset.metadata)}{" "}
            {citeAsset.metadata?.pages
              ? `| ${citeAsset.metadata.pages} pages`
              : citeAsset.metadata?.video_duration
                ? `| ${Math.ceil(citeAsset.metadata.video_duration / 60)} min`
                : ""}
          </p>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default CitationTooltip;
